import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportFiltersModule, ReportFiltersComponent } from '../../../components/report-filters/report-filters.component';
import { ReportHeaderComponent } from '../../../components/report-header/report-header.component';
import {
  SpeechTreatmentsReportTableComponentModule,
  SpeechTreatmentsReportTableComponent
} from '../components/speech-treatments-report-table/speech-treatments-report-table.component';
import { PaginationSortingModel } from '@/src/app/shared/components/table/models/pagination-sorting.model';
import { ReportConfig, ReportDownloadTypes } from '../../../components/report-filters/models/report-filters.model';
import { ReportTableDataService } from '../../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../../components/report-filters/services/report.service';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-speech-treatment-report',
  templateUrl: './speech-treatment-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    SpeechTreatmentsReportTableComponent,
    AsyncPipe,
    TranslateModule
  ]
})
export class SpeechTreatmentReportComponent {
  private reportTableDataService = inject(ReportTableDataService);
  reportService = inject(ReportService);

  reportConfig: ReportConfig = {
    type: 'SPEECH_TREATMENTS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true,
      [ReportDownloadTypes.EXCEL_ADMIN]: true,
      [ReportDownloadTypes.EXCEL_ADMIN_ID]: true
    },
    filters: {
      age: true,
      gender: true,
      geography: true,
      status: true,
      organizationsTree: true,
      practitioners: true,
      recordDate: true,
      speechTreatmentStates: true,
      speechTreatmentTypeStates: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList(this.reportConfig.type, this.reportService.model, pagination);
  }
}
@NgModule({
  imports: [
    CommonModule,
    ReportFiltersModule,
    SpeechTreatmentsReportTableComponentModule,
    TranslateModule,
    GeneralCommonsModule,
    SpeechTreatmentReportComponent
  ],
  exports: [SpeechTreatmentReportComponent]
})
export class SpeechTreatmentReportComponentModule {}
